import { Tooltip, OverlayTrigger } from 'react-bootstrap'

// Bootstrap Icons
const Archive = () => <i className="bi bi-archive"></i>
const Pencil = () => <i className="bi bi-pencil"></i>
const Trash = () => <i className="bi bi-trash"></i>
const Copy = () => <i className="bi bi-files"></i>
const Unarchive = () => <i class="bi bi-archive-fill"></i>

const ActionButton = ({ icon: Icon, tooltip, onClick, className = 'tw:text-blue-300 hover:tw:text-blue-800' }) => {
    return (
        <OverlayTrigger placement="top" overlay={<Tooltip>{tooltip}</Tooltip>}>
            <span className={`tw:cursor-pointer ${className}`} onClick={onClick}>
                <Icon />
            </span>
        </OverlayTrigger>
    )
}

const Button = ({ form, onEdit, onArchive, onUnarchive, onDuplicate, onDelete, isHovered }) => {
    const { status } = form

    const handleClick = (callback) => (e) => {
        e.stopPropagation()
        callback?.(form)
    }

    // Actions for ACTIVE forms (not archived)
    if (status === 'ACTIVE') {
        return (
            <div className="tw:absolute tw:top-0 tw:right-0 tw:flex tw:items-center tw:gap-2 tw:px-2 tw:py-0.5 tw:z-10">
                <ActionButton icon={Pencil} tooltip="Edit" onClick={handleClick(onEdit)} />
                <ActionButton icon={Copy} tooltip="Duplicate" onClick={handleClick(onDuplicate)} />
                <ActionButton icon={Archive} tooltip="Archive" onClick={handleClick(onArchive)} />
            </div>
        )
    }

    // Actions for ARCHIVED forms
    if (status === 'ARCHIVED') {
        return (
            <div className="tw:absolute tw:top-0 tw:right-0 tw:flex tw:items-center tw:gap-2 tw:px-2 tw:py-0.5 tw:z-10">
                <ActionButton icon={Unarchive} tooltip="Unarchive" onClick={handleClick(onUnarchive)} />
            </div>
        )
    }

    // Actions for DRAFT forms
    if (status === 'DRAFT') {
        return (
            <div className="tw:absolute tw:top-0 tw:right-0 tw:flex tw:items-center tw:gap-2 tw:px-2 tw:py-0.5 tw:z-10">
                <ActionButton icon={Pencil} tooltip="Rename" onClick={handleClick(onEdit)} />
                <ActionButton
                    icon={Trash}
                    tooltip="Delete"
                    onClick={handleClick(onDelete)}
                    className="tw:text-red-300 hover:tw:text-red-800"
                />
            </div>
        )
    }

    // Fallback - no actions
    return null
}

const ActionButtons = ({ form, onArchive, onUnarchive, onEdit, onDuplicate, onDelete, isHovered }) => {
    return (
        <div className="tw:relative tw:text-right">
            {/* Whether a creative uses the form, hidden while the row actions show */}
            <span className={`tw:transition-opacity tw:duration-200 ${isHovered ? 'tw:opacity-0' : 'tw:opacity-100'}`}>
                {form?.used ? 'Yes' : 'No'}
            </span>

            {isHovered && (
                <Button
                    form={form}
                    onEdit={onEdit}
                    onArchive={onArchive}
                    onUnarchive={onUnarchive}
                    onDuplicate={onDuplicate}
                    onDelete={onDelete}
                    isHovered={isHovered}
                />
            )}
        </div>
    )
}

export default ActionButtons
